/**
 * These are human-readable phone numbers that can be used to connect users with support staff.
 */
export enum HumanReadableHelpHotline {
    /**
     * This is the CX hotline for ZHL, which connects users to the Customer Experience team.
     */
    CUSTOMER_EXPERIENCE = '(833) 609-1160',
    /**
     * This is the generic help hotline for ZHL, which is listed in many different surfaces
     */
    GENERIC_HELP_LINE = '(888) 852-2212',
}
export const MAIN_CONTENT_ID = 'main-content-id';

export enum STORYBOOK_CONSTELLATION_VIEWPORTS {
    XS = 'constellationXs',
    SM = 'constellationSmMax',
    MD = 'constellationMdMax',
    LG = 'constellationLgMax',
    XL = 'constellationXlMax',
}

export const CYPRESS_INTEGRATION_TEST_IDS = {
    DEVELOPMENT_TOOLS: {
        GO_TO_MORTGAGE_DASHBOARD: 'go-to-mortgage-dashboard',
        GO_TO_APPLICATION_DASHBOARD: 'go-to-application-dashboard',
        CREATE_LOAN_APPLICATION_FOR_ACCOUNT: 'create-loan-application-for-account',
    },
    ABAD: {
        modal: 'abad-modal',
        header: 'abad-conversational-heading',
        centeredHeading: 'abad-title-heading',
        abadContent: 'abad-content',
        closeButton: 'abad-dismiss-button',
    },
    MOLECULAR: {
        CONFIRMATION_DIALOG: {
            MODAL: 'molecular-confirmation-dialog-modal',
            HEADER: 'molecular-confirmation-dialog-header',
            BODY: 'molecular-confirmation-dialog-body',
            CONFIRM_BUTTON: 'molecular-confirmation-dialog-confirm',
            CANCEL_BUTTON: 'molecular-confirmation-dialog-cancel',
        },
    },
    MORTGAGE_DASHBOARD: {
        HERO_IMAGE: 'mortgage-dashboard-hero-image',
        PAGE: 'mortgage-dashboard',
        EXPERIENCES: {
            NEW_APPLICATION: {
                RESOURCE_CARD: {
                    TITLE: 'landing-experience-info-heading',
                    CTA: 'landing-experience-info-cta',
                    MODAL: 'landing-modal-heading',
                    MODAL_CTA: 'landing-modal-cta',
                },
                UPSELL: {
                    TEXT: 'landing-experience-header',
                    CTA: 'landing-experience-hero-cta',
                    PHONE_CALL_LINK: 'landing-experience-phone',
                },
            },
            OUTSTANDING_TASKS: {
                RESOURCE_CARD: {
                    TITLE: 'offer-accepted-info-heading',
                    CTA: 'offer-accepted-info-cta',
                    MODAL: 'offer-accepted-modal-heading',
                },
                UPSELL: {
                    TITLE: 'offer-accepted-experience-header',
                    TEXT: 'offer-accepted-experience-text',
                    CTA: 'offer-accepted-experience-cta',
                },
            },
            OUTSTANDING_TASKS_FIRST_PARTY: {
                UPSELL: {
                    TITLE: 'outstanding-tasks-first-party-experience-header',
                    TEXT: 'outstanding-tasks-first-party-experience-text',
                    CTA: 'outstanding-tasks-first-party-experience-cta',
                    SECONDARY_CTA: 'outstanding-tasks-first-party-experience-secondary-cta',
                },
                RESOURCE_CARD: {
                    TITLE: 'outstanding-tasks-first-party-info-heading',
                    CTA: 'outstanding-tasks-first-party-info-cta',
                    MODAL: 'outstanding-tasks-first-party-modal-heading',
                },
            },
            VERIFIED_PRE_APPROVAL: {
                RESOURCE_CARD: {
                    TITLE: 'pre-approval-info-heading',
                    CTA: 'pre-approval-info-cta',
                    MODAL: 'pre-approval-modal-heading',
                    MODAL_CTA: 'pre-approval-modal-cta',
                },
                UPSELL: {
                    TEXT: 'pre-approval-experience-heading',
                    CTA: 'pre-approval-experience-cta',
                    MODAL: 'pre-approval-experience-modal-heading',
                },
            },
            VERIFIED_PRE_APPROVAL_FIRST_PARTY: {
                UPSELL: {
                    TEXT: 'verified-pre-approval-first-party-experience-heading',
                    CTA: 'verified-pre-approval-first-party-experience-cta',
                    MODAL: 'verified-pre-approval-first-party-experience-modal-heading',
                },
            },
            WAITING_TO_CLOSE: {
                UPSELL: {
                    TITLE: 'waiting-experience-header',
                    TEXT: 'waiting-experience-text',
                    CTA: 'waiting-experience-cta',
                },
                RESOURCE_CARD: {
                    TITLE: 'waiting-info-heading',
                    CTA: 'waiting-info-cta',
                    MODAL: 'waiting-modal-heading',
                },
            },
        },
        MODULES: {
            ASSIGNED_TEAM_MEMBERS_MODULE: {
                BASE_ID: 'assigned-team-member-module',
                CONTACT_CARD: {
                    BASE_ID: 'contactCards',
                    BASE_AVATAR: 'avatar',
                    BASE_HEADLINE: 'headline',
                    BASE_CONTENT: 'content',
                    BASE_CONTACT_METHODS: 'contactMethods',
                },
            },
        },
        VIEW_SAVED_INFORMATION: {
            CTA: 'access-your-info-cta',
        },
        RESOURCE_CARD_MODAL: 'resource-card-modal',
        ZDOCS_DOCUMENT_VIEWER: {
            MODAL: 'zdocs-document-viewer-modal',
            MODAL_FRAME: 'zdocs-document-view-modal-frame',
            MODAL_BANNER: 'zdocs-document-viewer-modal-banner',
            DOWNLOAD_BUTTON: 'zdocs-document-viewer-download-button',
            MOBILE_DOWNLOAD_BUTTON: 'zdocs-document-viewer-download-button-mobile',
            PRINT_BUTTON: 'zdocs-document-viewer-print-button',
            SHARE_BUTTON: 'zdocs-document-viewer-share-button',
        },
        WELCOME_BANNER: {
            BANNER: 'welcome-banner',
        },

        ERROR_PAGE: {
            ACTIVATION_FAILURE_HEADER: 'activation-failure-header',
            ACTIVATION_FAILURE_MESSAGE: 'activation-error-message',
        },
    },
    DASHBOARD_LINK: 'navbar-dashboard',
    CALLBACK_SCHEDULER: {
        SCHEDULE_APPOINTMENT_BUTTON: 'callback-scheduler-schedule-appointment-button',
        EXPERIENCES: {
            SUCCESS: {
                HEADING: 'callback-scheduler-success-heading',
                SCHEDULER_CX_HELP_HOTLINE_NUMBER: 'callback-scheduler-success-help-hotline-number',
                DASHBOARD_REDIRECT: 'callback-scheduler-success-dashboard-redirect',
                DPA_REDIRECT: 'callback-scheduler-success-dpa-redirect',
            },
            FAILURE: {
                HEADING: 'callback-scheduler-failure-heading',
                BUTTON: {
                    GET_PREAPPROVAL_CTA: 'callback-scheduler-failure-get-preapproval-cta',
                    DASHBOARD_CTA: 'callback-scheduler-failure-dashboard-cta',
                },
            },
        },
        TIMEZONE_SELECTOR: 'callback-scheduler-timezone-selector',
        HOUR_PICKER: {
            LOADING_OVERLAY: 'callback-scheduler-hour-picker-loading-overlay',
            HOUR_BUTTONS: 'callback-scheduler-hour-picker-hour-buttons',

            MORNING_TAB: 'callback-scheduler-hour-picker-morning-tab',
            AFTERNOON_TAB: 'callback-scheduler-hour-picker-afternoon-tab',
        },
        CAROUSEL: {
            LEFT_BUTTON: 'callback-scheduler-carousel-left-button',
            RIGHT_BUTTON: 'callback-scheduler-carousel-right-button',
            DAY_BUTTON: {
                ELEMENT: 'callback-scheduler-carousel-day-button',
                MONTH_DAY_LABEL: 'callback-scheduler-carousel-day-button-month-day-label',
            },
        },
    },
    BLEND_ACCESS_FAILURE: {
        SELF_RECOVERY_LOAN_DISCOVERY_FORM: {
            HEADING: 'self-recovery-loan-discovery-form-heading',
            SUBHEADING: 'self-recovery-loan-discovery-form-subheading',
            FIRST_NAME: 'self-recovery-loan-discovery-form-first-name',
            LAST_NAME: 'self-recovery-loan-discovery-form-last-name',
            EMAIL: 'self-recovery-loan-discovery-form-email',
            NEXT_BUTTON: 'self-recovery-loan-discovery-form-next-button',
        },
        SELF_RECOVERY_LOAN_VERIFICATION_FORM: {
            HEADING: 'self-recovery-loan-verification-form-heading',
            SUBHEADING: 'self-recovery-loan-verification-form-subheading',
            STREET_ADDRESS: 'self-recovery-loan-verification-form-street-address',
            UNIT_NUMBER: 'self-recovery-loan-verification-form-unit-number',
            CITY: 'self-recovery-loan-verification-form-city',
            STATE: 'self-recovery-loan-verification-form-state',
            ZIP_CODE: 'self-recovery-loan-verification-form-zip-code',
            SOCIAL_SECURITY_NUMBER: 'self-recovery-loan-verification-form-social-security-number',
            PHONE_NUMBER: 'self-recovery-loan-verification-form-phone-number',
            SUBMIT_BUTTON: 'self-recovery-loan-verification-form-submit-button',
            GO_BACK_BUTTON: 'self-recovery-loan-verification-form-go-back-button',
        },
    },
} as const;

export const ALL_STATE_ABBREVIATIONS = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
] as const;

export enum ERROR_PREFIXES {
    APOLLO = '[APOLLO]',
    ANALYTICS = '[ANALYTICS]',
    DASHBOARD = '[DASHBOARD]',
    APPLICATION_SESSION = '[APPLICATION SESSION]',
    OAUTH = '[OAUTH]',
    PUBLIC_SETTINGS_API = '[Public Settings API]',
    MAX_API = '[MAX API]',
}

export const CYPRESS_ID_ATTRIBUTE = 'data-testid';

export enum TIME_UNITS {
    MILLISECONDS_IN_SECOND = 1000,
    MILLISECONDS_IN_MINUTE = 60_000,
    MILLISECONDS_IN_HOUR = 3_600_000,
    ONE_SECOND = 1,
    SECONDS_IN_MINUTE = 60,
    MINUTES_IN_HOUR = 60,
    HOURS_IN_DAY = 24,
    DAYS_IN_YEAR = 365,
}
